import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { labels } from '../../../../../../../util/utils';
import { trialBalanceType, non_MEST } from '../../../../../../../util/uiconstants';
import { getInUserNumberFormat } from '../../../../../../Common/Accounts/AccountSummary/AccountSummaryConfig';
import ClientDataModal from '../Common/ClientDataModal/clientDataModal';
import Button from '../../../../../BaseComponentWrappers/MotifButton';
import EllipsesControl from '../../../../../../Common/EllipsesControl/EllipsesControl';

export default function AnalysisPeriodBalanceCellRenderer(params) {
	const [showClientDataModal, setShowClientDataModal] = useState(false);
	
	const userPreferences = useSelector((store) => store.userPreferences);

	const trialBalance = params?.data?.trialBalanceData.find((item) => item?.stEntityId === params?.selectedStEntityId && item?.trialBalanceTypeId === trialBalanceType.Planning);
	
	const numberFormated = useMemo(() => {
		return trialBalance?.financialStatements?.length > 0
			? getInUserNumberFormat(trialBalance.financialStatements[0][params.field], true, 0, '', userPreferences)
			: null;
	}, [trialBalance, params.field]);

	const isMultiple = trialBalance?.financialStatements?.length > 1;

	const Label = isMultiple ? labels.multiple : numberFormated;

	const displayCheck = trialBalance?.trialBalanceTypeId === trialBalanceType.Planning;

	const buttonClick = (e) => {
		setShowClientDataModal(!showClientDataModal);
	};

	return (
		<StyledBalance className="StyledBalance">
			{params.showClientModal && !displayCheck && <span> {'-'} </span>}
			{!params.showClientModal && !isMultiple && (
				<section className="text-renderer">
					<EllipsesControl content={displayCheck && numberFormated ? numberFormated : '-'} noOfLines={1} />
				</section>
			)}
			{params.showClientModal && displayCheck && numberFormated && (
				<Button
					variant="text-alt"
					className="BalanceButton"
					onClick={buttonClick}
					showLabel
					isEllipsed
					buttonLabel={displayCheck && Label ? Label : '-'}
					noOfLines={1}
				/>
			)}
			{!params.showClientModal && isMultiple && <span> {'-'} </span>}
			{showClientDataModal && params.showClientModal && (
				<ClientDataModal account={params.data} stEntityId={params.selectedStEntityId} showModal={showClientDataModal} setShowModal={setShowClientDataModal} />
			)}
		</StyledBalance>
	);
}

const StyledBalance = styled.section`
	display: flex;
	justify-content: flex-end;
	.BalanceButton {
		font-size: var(--px-12);
		font-weight: 400;
		line-height: var(--px-20);
		max-width: 100%;
		color: var(--blue-600);
	}
	.text-renderer {
		width: auto;
		max-width: 90%;
		.ellipses {
			font-size: var(--px-12);
			font-weight: 300;
			line-height: var(--px-22);
		}
	}
`;
